export default __webpack_public_path__ + "static/mongodb-associate-dba-badge-aa937663b1473fa1f198bbaa6a2eafa6.png";